var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentMerge = function SvgDocumentMerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 20 20"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.064 13.206a.8.8 0 0 1 1.13.058L19.663 16l-2.47 2.736a.8.8 0 0 1-1.187-1.072l.78-.864H13.2a.8.8 0 0 1 0-1.6h3.586l-.78-.864a.8.8 0 0 1 .058-1.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.998 18.936V1.065A.4.4 0 0 1 3.699.8l.748.855a.4.4 0 0 0 .602 0L6.197.344a.4.4 0 0 1 .602 0l1.148 1.312a.4.4 0 0 0 .602 0L9.697.344a.4.4 0 0 1 .602 0l1.148 1.312a.4.4 0 0 0 .602 0L13.197.344a.4.4 0 0 1 .602 0l1.148 1.312a.4.4 0 0 0 .602 0l.748-.855a.4.4 0 0 1 .701.264v9.963a2.794 2.794 0 0 0-2.274.693 2.787 2.787 0 0 0-.86 1.479H13.2a2.8 2.8 0 0 0-1.652 5.061.398.398 0 0 0-.101.083l-1.148 1.312a.4.4 0 0 1-.602 0l-1.148-1.312a.4.4 0 0 0-.602 0l-1.148 1.312a.4.4 0 0 1-.602 0l-1.148-1.312a.4.4 0 0 0-.602 0l-.748.855a.4.4 0 0 1-.7-.264Z"
  })));
};
export default SvgDocumentMerge;